import PropTypes from "prop-types"
import React, { useContext, useState, useEffect} from "react"
import { Link, useHistory } from "react-router-dom"
import { connect } from "react-redux"
import { deleteFromCart, deleteAllFromCart, cartItemData } from "../../redux/actions/cartActions"
import { AuthContext } from "../../common/Auth"
import useVisible from './useVisible';
import { useThemeSettings } from "../../layouts/state/useThemeSettings"
import { useThemeSettingsData } from "../../layouts/state/useThemeSettingsData"

const LoginIconGroup = ({ iconWhiteClass}) => {

    const { ref,  setIsVisible,  setIsVisibleCart, isAccount, setIsAccount } = useVisible({ isVisible: false, isVisibleCart: false, isAccount: false });
    const { themeSettingsData, settingData, login, enableLandingPage, user, logout, userType, isAllowSelfRegistration, paymentMethodsSettings } = useContext(AuthContext)
    const userId = user?.userId
    const [hoverClr, setHoverClr] = useState('');
    const iconColor = {
        color: menuStyleData?.menuRightIconcolor
    }
    const { 
        isPublic, 
        isShowMyAccount, 
        themedefaultColor 
    } = useThemeSettings({ settingData });

    const {
        menuStyleData,
        isLPublic,
    } = useThemeSettingsData({ themeSettingsData })
    let IsPublicData = isLPublic !== undefined ? isLPublic : isPublic ?? true

    useEffect(() => {
        setHoverClr(menuStyleData.menuRightIconHovercolor ? menuStyleData.menuRightIconHovercolor : themedefaultColor)
    }, [themedefaultColor, menuStyleData]);

    const handleClick = e => {
        setIsVisible(false)
        setIsVisibleCart(false)
        setIsAccount(!isAccount)
    }

    return (
        <>

            <div ref={ref} className="w-100">
                <style>
                    {`.dhover:hover {
                                color: ${hoverClr} !important;
                            }`}
                </style>

                {(!IsPublicData && enableLandingPage) &&
                    <div className={`header-right-wrap pt-2 pb-2 ${iconWhiteClass ? iconWhiteClass : ''} icon-auto`}>
                        {isShowMyAccount &&
                            <div className="same-style account-setting d-lg-block">
                                <button
                                    className="dhover account-setting-active"
                                    onClick={(e) => handleClick(e)}
                                >
                                    <i
                                        className="dhover pe-7s-user-female"
                                        style={iconColor}
                                        title="Account"
                                    />
                                </button>
                                <div className={`account-dropdown  ${isAccount ? 'active' : ''}`}>
                                    <ul>
                                        <li>
                                            <Link to={process.env.PUBLIC_URL + '/login'}>Login</Link>
                                        </li>

                                        {!userId && isAllowSelfRegistration && (
                                            <li>
                                                <Link to={process.env.PUBLIC_URL + '/register'}>
                                                    Register
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </>
    )
}


const mapStateToProps = state => {
    return {
        artworkList: state.productData.artworkList,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        deleteFromCart: (item, _addToast, isPriceBreak, mainIndex, rowIndex) => {
            dispatch(deleteFromCart(item, _addToast, isPriceBreak, mainIndex, rowIndex))
        },
        deleteAllFromCart: (_addToast) => {
            dispatch(deleteAllFromCart(_addToast))
        },
        cartItemData: (Data) => {
            dispatch(cartItemData(Data))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginIconGroup)
